import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { root } from '../../../../../../../../../store/constants';
import { getCardsWithCardNumber } from '../selectors/getCardsWithCardNumber';
import { ICards } from '../../../../../../../../../store/model/cards/types';
import { cardsRestPatch } from '../../../../../../../../../rest/effects/card/card/api/helper/cardsRestPatch';

export const removePrefixes = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        root.App.controller.boardCardPrefixInfo.resetBoarCardPrefixInfo();
        const cards = getCardsWithCardNumber(getState(), boardId);
        if (!cards.length) return Promise.resolve();

        const cardsForUpdate: ICards = {};

        cards.forEach(card => {
            root.App.controller.boardCardPrefixInfo.addedCardsCount = root.App.controller.boardCardPrefixInfo.totalCardsCount - cards.length;
            root.App.controller.boardCardPrefixInfo.addCardForRollback({ id: card.id, cardNumber: card.cardNumber || '' });
            cardsForUpdate[card.id] = { cardNumber: '' };
        });

        return dispatch(cardsRestPatch(cardsForUpdate));
    }
    return action;
}
